<template>
  <div class="applyManage">
    <template v-if="isApplyManage">
      <!-- title 标题 -->
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

      <!-- 基本信息导入功能 -->
      <ots-custom-dialog :dialog.sync="baseImportDialog" title="基本信息导入">
        <!-- 基本信息导入表单 -->
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <!-- (1) 基本数据导入模板下载 -->
              <el-form-item label="1.模板下载">
                <span style="color: #006aff" @click="excelTempCreateExt()" class="cp">
                  <i class="el-icon-download"></i>
                  下载基本信息导入数据模板
                </span>
              </el-form-item>
              <!-- (2) 预报名 -->
              <el-form-item label="2.导入文件">
                <el-checkbox v-model="importForm.preRegistrationState" :true-label="1" :false-label="0">预报名</el-checkbox>
              </el-form-item>
              <!-- (3) 限定学生范围 -->
              <el-form-item >
                <el-checkbox v-model="importForm.limitRegionState" :true-label="1" :false-label="0">限定学生范围</el-checkbox>
              </el-form-item>
              <!-- (4) 基本信息批量导入文件 -->
              <el-form-item v-model="importForm.Filedata">
                <ots-upload-file :httpRequest="handleFormData" fileType="xlsx"/>
              </el-form-item>
            </el-form>
            <!-- (5) 基本信息导入提示信息 -->
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；</div>
              </div>
            </div>
          </div>
        </template>
        <!-- 基本信息导入按钮 -->
        <template v-slot:footer>
          <el-button round @click="baseImportDialog = false">取消</el-button>
          <el-button round type="primary" @click="rightImport">导入</el-button>
        </template>
      </ots-custom-dialog>

      <!-- 照片批量上传 -->
      <ots-custom-dialog :dialog.sync="upLoadImgDialog" title="照片上传">
        <template v-slot:content>
          <div class="exportDialog">
            <!-- (1) 批量导入照片文件 -->
            <el-form>
              <el-form-item label="请选择照片信息文件"  v-model="upLoadImgForm.Filedata">
                <ots-upload-file ref="importImg" :httpRequest="handleImgFormData" fileType="zip"/>
              </el-form-item>
            </el-form>
            <!-- (2) 图片导入提示 -->
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：只能上传扩展名为<span class="col_red">.zip</span>的文件；</div>
                <div>2：文件大小不能超过<span class="col_red">10M</span>；</div>
                <div>3：文件名不能是中文,<span class="col_red">照片以证件号命名；</span></div>
                <div>4：压缩包内只能是照片（不包含文件夹）；</div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="upLoadImgDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitUploadImg">导入</el-button>
        </template>
      </ots-custom-dialog>

      <!-- 重置密码 -->
      <ots-custom-dialog :dialog.sync="repeatPsdDialog" title="重置密码" width="40%">
        <template v-slot:content>
          <div class="repeatPsd">
            确定将考生<span>{{ editPsdQuery.realName }}</span>的密码重置？重置后，密码为其<span>证件号后六位（不够六位前面补0）</span>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="repeatPsdDialog = false">取消</el-button>
          <el-button round type="primary" @click="submitRepeatPsd">确定</el-button>
        </template>
      </ots-custom-dialog>

      <!-- table 表格 -->
      <ots-table-group-new
        @roleType="roleTypeFN"
        :selectList="teaSelectList"
        :requestForm="requestForm"
        @search="search"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeCity="changeCityFN"
        @changeNum="changeNum"
        @changePage="changePage"
      >
      </ots-table-group-new>

    </template>

    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import { getSinglePlan } from "@/http/modules/examSet/examBatch";
import { selectList, planStudentImport, studentExport, excelTempCreate } from "@/http/modules/custom";
import {judgeIsPay} from "@/http/modules/home.js"

export default {
  name: "applyManage",
  data() {
    return {
      /* *** 报名结束时间 *** */
      endTime: "",
      /* *** 导入/导出/新增 按钮 *** */
      mainTopBtnList: [
        {
          title: "批量导入",
          select: true,
          plain: true,
          children: [
            { title: "基本信息导入", fn: this.baseImport },
            { title: "学生照片导入", fn: this.phoneImport },
          ],
        },
        {
          title: "导出",
          plain: true,
          fn: this.exportStu,
        },
        {
          title: "新增",
          fn: this.addUser,
        },
      ],
      /* *** 基本信息导入弹窗开关 *** */
      baseImportDialog: false,
      /* *** 基本信息导入表单参数 *** */
      importForm: {
        limitRegionState: 1,
        preRegistrationState: 1,
        planId: "",
        file: "",
      },
      /* *** 批量上传图片弹窗开关 *** */
      upLoadImgDialog: false,
      /* *** 重置密码弹窗开关 *** */
      repeatPsdDialog: false,
      /* *** 重置密码表单参数 *** */
      editPsdQuery: {
        realName: "",
        userId: "",
        password: "",
        confirmPassword: "",
      },
      /* *** 批量图片上传参数 *** */
      upLoadImgForm: {
        Filedata: "",
      },
      /* *** 搜索表单参数 *** */
      requestForm: {
        page: 1,
        size: 10,
        planId: "",
        schoolId: "",
        stationId: [''],
        orders: "",
        stateType: "",
        photoState: "",
        payType: "",
        realName: "",
        cardNo: "",
        phone: "",
      },
      /* *** 搜索表单下拉列表数据 *** */
      teaSelectList: [
        {
          title: "考试批次",
          type: "select",
          isSearch: true,
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "院校",
          type: "select",
          isSearch: true,
          requestKey: "schoolId",
          label: "name",
          value: "id",
          data: [ { id: "", name: "全部" } ],
        },
        {
          title: this.isSetStateName,
          type: "select",
          requestKey: "stationId",
          isSearch: true,
          multiple: true,
          label: "name",
          value: "id",
          data: [ { id: "", name: "全部" } ],
        },
        {
          title: "人身核验状态",
          type: "select",
          isSearch: true,
          requestKey: "photoState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 0, name: "系统不通过" },
            { id: 1, name: "系统通过" },
            { id: 2, name: "人工通过" },
            { id: 3, name: "无照片" },
          ],
        },
        {
          title: "审核状态",
          type: "select",
          requestKey: "stateType",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "缴费状态",
          type: "select",
          isSearch: true,
          requestKey: "payType",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "已缴费" },
            { id: 0, name: "未缴费" },
          ],
        },
        {
          title: "姓名",
          type: "input",
          requestKey: "realName",
          placeholder: "请输入",
        },
        {
          title: "证件号",
          type: "input",
          requestKey: "cardNo",
          placeholder: "请输入",
        },
        {
          title: "手机号",
          type: "input",
          requestKey: "phone",
          placeholder: "请输入",
        },
      ],
      /* *** 表格头配置 *** */
      tableHeader: [
        {
          title: "姓名",
          width: "80",
          prop: "realName",
          fixed: "left",
        },
        {
          title: "性别",
          width: "60",
          prop: "sex",
        },
        {
          title: "证件号",
          width: "200",
          prop: "cardNo",
        },
        {
          title: "手机号",
          width: "115",
          prop: "phone",
        },
        {
          title: "院校",
          width: "200",
          prop: "school",
        },
        {
          title: "函授站",
          prop: "station",
          width: "200",
        },
        {
          title: "报考课程",
          prop: "course",
          width: "100",
        },
        {
          title: "照片",
          type: "img",
          prop: "photo",
          fixed: "right",
        },
        {
          title: "人身核验状态",
          prop: "photoState",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              人工通过: "green",
              系统通过: "green",
              系统不通过: "red",
              无照片: "red",
            };
            return options[scope.row.photoState];
          },
          width: "120",
          fixed: "right",
        },
        {
          title: "审核状态",
          prop: "stateType",
          type: "state",
          stateFlag: (scope) => {
            const options = {
              待初审: "orange",
              初审不通过: "red",
              待终审: "orange",
              终审通过: "green",
              终审不通过: "red",
            };
            return options[scope.row.stateType];
          },
          fixed: "right",
          width: "110",
        },
        {
          title: "缴费状态",
          prop: "payType",
          type: "tag_Q",
          tagColor: (scope) => {
            const options = {
              已缴费: "",
              未缴费: "col_grayQ",
            };
            return options[scope.row.payType];
          },
          width: "85",
          fixed: "right",
        },
        {
          title: "操作",
          type: "buttons",
          width: "165",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          btnList: [
            {
              title: "重置密码",
              click: this.repeatPsd,
            },
            {
              title: "编辑",
              formatter: (scope) => {
                if (scope.row.stateType == "终审通过") {
                  return true;
                } else {
                  return false;
                }
              },
              click: this.edit,
            },
            {
              title: "删除",
              formatter: (scope) => {
                // 考场安排后不能删除
                return scope.row.isSetClass == 1;
              },
              click: this.delet,
            },
          ],
        },
      ],
      /* *** 表格数据 *** */
      tableData: [],
      /* *** 表格按钮 *** */
      batchOperBtn: [],
      /* *** 数据条数 *** */
      pagination: {
        total: 0,
      },
      // 审核状态
      needAudit: "",
      // endPayTime: '',
      roleType: "",
      // 自定义搜索列表
      customSearch: [],
      // 函授站标题
      isSetStateName: "",
      /* ** 是否设置了考点场次 ** */
      optionalSession: '',
      // 是否有批次配置了缴费
      // needPayMent: this.$store.state.IsHavePayPlan,
    };
  },
  computed: {
    isApplyManage() {
      return this.$route.name === "applyManage";
    },
  },
  watch: {
    "requestForm.planId": function (val) {
      this.planSearch();
    },
    $route() {
      if (this.$route.name == "applyManage") {
        this.getTableList();
      }
    },
  },
  mounted() {
    this.getData();
    this.isSetState();
  },
  methods: {
    /***********************************
     * @this 下载导入模板
     ***********************************/
    excelTempCreateExt() {
      excelTempCreate().then((res) => {
        window.location.href = res.data;
      });
    },

    /***********************************
     * @isSetState 系统是否设置了函授站标题
     ***********************************/
    isSetState() {
      this.teaSelectList[2].title = "函授站";
      this.tableHeader[5].title = "函授站";
    },

    /***********************************
     * @this 用户权限
     ***********************************/
    roleTypeFN(val) {
      this.roleType = val;
    },

    /*****************************
     * @this 配置表单信息
     *****************************/
    getData() {
      // 获取动态表单搜索项
      const typeList = ['select', 'province', 'subject', 'nation', 'politicalStatus', 'level'];

      // 自定义字段配置
      this.mixin_setUserExtInfo().then((res) => {
        res.data.map((item) => {
          // 是否作为查询条件
          if (item.queryCondition == 1) {
            if (typeList.includes(item.type)) {
              if (item.valueVo) {
                let search = {
                  title: item.displayName,
                  type: "select",
                  requestKey: item.name,
                  label: "name",
                  value: "name",
                  data: [
                    { name: "全部" },
                    ...item.valueVo,
                  ],
                };
                this.customSearch.push(search);
              }
            } else if (item.type == "text") {
              let search = {
                title: item.displayName,
                type: "input",
                requestKey: item.name,
                placeholder: "请输入",
              };
              this.customSearch.push(search);
            } else if (item.type == "provinceCity") {
              let search = {
                title: item.displayName,
                type: "cascader",
                requestKey: item.name,
                label: "name",
                value: "name",
                data: [
                  { name: "全部" },
                  ...item.valueVo,
                ],
              };
              this.customSearch.push(search);
            }
          }
          if (item.type == "imageUpload") {
            let tables = {
              title: item.displayName,
              type: "img",
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          } else {
            let tables = {
              title: item.displayName,
              width: "120",
              prop: item.name,
            };
            this.tableHeader.push(tables);
          }
        });
        this.requestForm = Object.assign(this.requestForm, res.requestForm);
        this.teaSelectList = [...this.teaSelectList, ...this.customSearch];
      });

      // 获取批次下拉列表
      this.mixin_getSelectPlan().then((data) => {
        this.$set(this.teaSelectList[0], "data", data);
        this.requestForm.planId = data[0].id;
      });

      // 获取当前考试批次信息
      this.mixin_getCurrentPlanInfo().then((data) => {
        this.endTime = moment(data.endAudit).format( "YYYY年MM月DD日 HH时mm分ss秒" );
        this.importForm.planId = data.id;
      });

      // 获取选项数据(院校列表)
      this.mixin_getSelectSchool().then((data) => {
        let newSchoolList = [
          { id: "", name: "全部" },
          ...data,
        ];
        this.$set(this.teaSelectList[1], "data", newSchoolList);
      });

      // 获取选项数据(函授站列表)
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [
          { id: "", name: "全部" },
          ...data,
        ];
        this.$set(this.teaSelectList[2], "data", newStationList);
      });

      // 是否有批次设置了缴费
      judgeIsPay().then( ({data}) => {
        if (data != 1) {
          this.tableHeader.map( (e, i) => {
            if (e.prop == 'payType') {
              this.tableHeader.splice(i, 1);
            }
          })

          this.teaSelectList.map( (item, index) => {
            if (item.requestKey == 'payType') {
              this.teaSelectList.splice(index, 1);
            }
          })
        }
      })

    },

    /****************************************************
     * @this (baseImport)根据考点场次安排,配置是否弹出弹窗
     ****************************************************/
    baseImport() {
      this.importForm.limitRegionState = 1;
      this.importForm.preRegistrationState = 1;
      this.baseImportDialog = true;
    },

    /* *** 批量导入基本信息文件处理 *** */
    handleFormData(val) {
      this.importForm.file = val.file;
    },

    /**********************************
     * @this 批量导入文件
     **********************************/
    rightImport() {
      if (this.optionalSession) {
        if (this.importForm.preRegistrationState != 1) {
          this.$message.warning('批次设置了学生选考点考场，请勾选 “预报名” 或 “让学生自己报名” ！');
          return;
        }
      }
      if (!this.importForm.file) {
        this.$message.warning("请选择文件！");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      };
      planStudentImport(fd).then((res) => {
        if (res.code) {
          this.baseImportDialog = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
          this.importDialog = false;
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.address;
            }
          }).catch(() => {});
          this.getTableList();
        }
      });
    },

    /**********************************
     * @this 照片
     **********************************/
    phoneImport() {
      this.upLoadImgDialog = true;
    },

    /**********************************
     * @this 文件
     **********************************/
    handleImgFormData(val) {
      this.upLoadImgForm.Filedata = val.file;
    },

    /**********************************
     * @this 批量导入(照片)
     **********************************/
    submitUploadImg() {
      if (!this.upLoadImgForm.Filedata) {
        this.$message.error("请选择文件");
        return;
      }
      let param = {
        file: this.upLoadImgForm.Filedata,
      };
      const fd = new FormData();
      for (let item in param) {
        fd.append(item, param[item]);
      }
      this.$api.applyManage.batchImportUserPhoto(fd).then((res) => {
        if (res.code) {
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
          const totalNum = parseInt(res.data.allCount);
          const successNum = totalNum - failNum;
          let message = `导入完成，成功导入照片${successNum}张，导入失败${failNum}张`;
          this.upLoadImgDialog = false;
          this.$confirm(message, "导入结果", {
            confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
              if (failNum > 0) {
                window.location.href = res.data.address;
              }
          }).catch(() => {});
          this.getTableList();
        }
      });
    },

    /**********************************
     * @this 新增用户
     **********************************/
    addUser() {
      this.$router.push({
        path: "applyManage/applyManageAdd",
        query: {
          planId: this.requestForm.planId,
        },
      });
    },

    /**********************************
     * @this 获取table列表数据
     **********************************/
    getTableList() {
      // 根据批次修改审核列表
      getSinglePlan({ planId: this.requestForm.planId }).then((res) => {
        // (1) 所选批次是否设置了自选考点场次
        this.optionalSession = res.data.optionalSession == 1;
        // (2) 设置表单 (审核状态)
        if (res.data.needAudit == 1) {
          let dataList = [
            { id: "", name: "全部" },
            { id: "3", name: "待终审" },
            { id: "4", name: "终审通过" },
            { id: "5", name: "终审不通过" },
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        } else if (res.data.needAudit == 2) {
          let dataList = [
            { id: "", name: "全部" },
            { id: "1", name: "待初审" },
            { id: "2", name: "初审不通过" },
            { id: "3", name: "待终审" },
            { id: "4", name: "终审通过" },
            { id: "5", name: "终审不通过" },
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        } else {
          let dataList = [
            { id: "", name: "全部" },
            { id: "4", name: "审核通过"},
            { id: "6", name: "审核不通过"}
          ];
          this.$set(this.teaSelectList[4], "data", dataList);
        }

        // (3) 批次是否配置了需要缴费
        if (this.$store.state.IsHavePayPlan != 1) {
          this.tableHeader.map( (e, i) => {
            if (e.prop == 'payType') {
              this.tableHeader.splice(i, 1);
            }
          })

          this.teaSelectList.map( (item, index) => {
            if (item.requestKey == 'payType') {
              this.teaSelectList.splice(index, 1);
            }
          })
        }
      });

      // 修改: 函授站为多选
      let params = {...this.requestForm};
      if (typeof(params.stationId) == 'object') {
        params.stationId = params.stationId.join(',');
      }

      // 自定义字段选择了全部
      for (let key in params) {
        if (params[key] == '全部') { params[key] = '' }
      }

      // 重新查询表格数据
      selectList(params).then((res) => {
        if (res.code) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
          // 获取自定义字段信息
          res.data.records.forEach((e) => {
            e.extData.forEach((item) => {
              e[item.name] = item.value;
            });
          });
        }
      });
    },

    /*******************************
     * @this 重置密码
     *******************************/
    repeatPsd(val) {
      this.repeatPsdDialog = true;
      let { stuid, cardNo } = val;
      let resetPassword = "";
      let hanzi = new RegExp("[\u4e00-\u9fa5]");
      if (hanzi.test(cardNo)) {
        resetPassword = "000000";
      } else if (cardNo.length >= 6) {
        resetPassword = cardNo.substring(cardNo.length - 6);
      } else {
        let zeroNum = 6 - cardNo.length;
        for (let i = 0; i < zeroNum; i++) {
          resetPassword = resetPassword + "0";
        }
        resetPassword = resetPassword + cardNo;
      }
      this.editPsdQuery = {
        userId: stuid,
        password: resetPassword,
        confirmPassword: resetPassword,
        tenant: window.localStorage.getItem("tenant"),
      };
    },

    /*******************************
     * @this 重置密码提交操作
     *******************************/
    submitRepeatPsd() {
      this.$api.login.editPsd(this.editPsdQuery).then((res) => {
        if (res.code) {
          this.repeatPsdDialog = false;
          this.$message({
            message: "密码修改成功",
            type: "success",
          });
        }
      });
    },

    /*************************************
     * @this 修改
     *************************************/
    edit(val) {
      this.$router.push({
        path: "/applyManage/applyManageAdd",
        query: val,
      });
    },

    /*************************************
     * @this 删除
     *************************************/
    delet(val) {
      let stuid = val.stuid;
      let planId = val.planId;
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$api.applyManage.del({ stuid, planId }).then((res) => {
          if (res.code) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getTableList();
          }
        });
      });
    },

    /*******************************
     * @this 导出
     *******************************/
    exportStu() {
      let { page, size, ...queryFrom } = this.requestForm;
      if (typeof(queryFrom.stationId) == 'object') {
        queryFrom.stationId = queryFrom.stationId.join();
      }
      studentExport(queryFrom).then((res) => {
        if (res.code) {
          window.open(res.data);
        }
      });
    },

    /*************************************
     * @this 分页
     *************************************/
    search() {
      this.requestForm.page = 1;
      this.getTableList();
    },

    /*************************************
     * @this (planSearch)重新搜索表格数据
     *************************************/
    planSearch() {
      this.requestForm.page = 1;
      this.requestForm.stateType = "";
      this.getTableList();
    },

    changeNum(num) {
      this.requestForm.size = num;
      this.getTableList();
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableList();
    },

    changeCityFN(e, attr) {
      this.requestForm[attr] = e.toString();
    },
  },
};
</script>

<style lang="less" scoped>
.applyManage {
  .el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ff9500;
    height: 48px;
    line-height: 48px;
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #ff9500;
      margin-left: -10px;
      margin-top: -7px;
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #ff9500;
    }
  }
  /deep/ .unDistributed {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #fe5958;
      border-radius: 50%;
    }
  }
  /deep/ .unFinish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #006aff;
      border-radius: 50%;
    }
  }
  /deep/ .wait {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #f27900;
      border-radius: 50%;
    }
  }
  /deep/ .finish {
    position: relative;
    margin-left: 10px;
    &:after {
      content: " ";
      position: absolute;
      left: -10px;
      top: 7px;
      width: 5px;
      height: 5px;
      background-color: #1dbf60;
      border-radius: 50%;
    }
  }
}
.exportDialog {
  .impExplain {
    margin-top: 32px;
    color: #9299a6;
    // display: flex;
    .tipTitle {
      flex-shrink: 0;
      display: block;
      margin-bottom: 12px;
    }
    div {
      line-height: 1.8;
    }
  }
}
.downTemplate {
  display: block;
  padding: 8px 0 0px 0;
  color: #3388ff;
  font-size: 13px;
  text-decoration: none;
}
.repeatPsd {
  font-size: 14px;
  color: #45494d;
  span {
    color: #2d2f33;
    font-weight: 600;
  }
}
</style>
